import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const SelectedItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 6px 16px;
  font-size: 13px;
  width: 94%;
  line-height: 20px;
  margin-top: 5px;
  border-radius: 4px;
  border: 3px solid ${({ theme }) => theme.colors.grey100};
  color: ${({ theme }) => theme.colors.grey002};
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.grey002};
  font-size: 14px;
  font-weight: 400;
  ${({ clickable }) => clickable && 'cursor: pointer;'}
`;

export const SearchByItemsFitlerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #e3e6ea;
`;

export const SearchByItemsFitlerLabel = styled(typography.TitleOneBoldTypography)`
  line-height: 22px;
`;

export const SelectedItemClearIcon = styled.div`
  font-style: normal;
  color: ${({ theme }) => theme.colors.grey002};
  padding: 5px 10px;
  cursor: pointer;

  &:before {
    content: '\\e918';
    font-family: 'Icomoon';
  }

  &:hover {
    color: ${({ theme }) => theme.colors.redMain};
    transition: all 150ms ease-in-out;
  }
`;
